import { Link } from "react-router-dom";
import { Flame } from "lucide-react";
import { CATEGORY_LABELS } from "../lib/constants";
import { tintFor } from "./ArticleCard";

// Rank badges are filled with the story's own section tint, so the column
// reads as a little stack of coloured pills.
export function TrendingSidebar({ items = [] }) {
    return (
        <aside data-testid="trending-sidebar" className="panel p-6 sticky top-28">
            <div className="flex items-center gap-2.5 mb-4">
                <span className="grid place-items-center w-9 h-9 rounded-full bg-accent-soft text-accent">
                    <Flame size={16} />
                </span>
                <h4 className="eyebrow text-foreground">Trending Now</h4>
            </div>
            <ol className="space-y-1">
                {items.map((a, i) => (
                    <li key={a.id}>
                        <Link
                            to={`/article/${a.id}`}
                            data-testid={`trending-item-${a.id}`}
                            className="group flex gap-3.5 p-3 rounded-xl hover:bg-surface-raised transition-colors duration-200"
                        >
                            <span
                                className={`grid place-items-center w-8 h-8 shrink-0 rounded-full font-mono text-xs font-medium tabular-nums ${tintFor(a.category)}`}
                            >
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <div className="min-w-0">
                                <span className="eyebrow !text-[10px] text-dim">
                                    {CATEGORY_LABELS[a.category] || a.category}
                                </span>
                                <h5 className="font-display text-sm font-medium leading-snug mt-1 text-foreground group-hover:text-accent transition-colors duration-200">
                                    {a.title}
                                </h5>
                            </div>
                        </Link>
                    </li>
                ))}
                {items.length === 0 && <li className="text-sm text-dim py-4 px-3">No trending stories yet.</li>}
            </ol>
        </aside>
    );
}
